



import { defineComponent, onMounted, ref, watch } from "@vue/composition-api";
import { ScoutPlan } from "@/pb/scout/contract/v1/contract_pb";
import ContractPanel from "@/components/Pages/Scout/elements/ContractPanelWrapper/ContractPanel/index.vue";
import { fetchAndStoreContract } from "@/helpers/contract-helper";
import { Contract } from "@/components/Pages/Scout/elements/ContractPanelWrapper/ContractPanel/types";
import { useStore } from "@/store";

export default defineComponent({
  name: "ContractPanelWrapper",
  components: { ContractPanel },
  setup() {
    const store = useStore();

    const contract = ref<Contract>({
      scoutPlan: ScoutPlan.SCOUT_PLAN_UNSPECIFIED,
      remainingTicketsCount: 0,
      expirationAtMs: undefined,
      scoutTargetGraduateYears: []
    });

    // スカウト契約情報が変更されたらUIを即更新する
    watch(
      () => store.state.domains.user.scoutPlan,
      () => {
        loadContract();
      }
    );

    const loadContract = async () => {
      const storedScout = store.state.domains.user.scoutPlan as Contract;
      // スカウト契約の情報がvuex storeに存在する場合はそれを使う
      // scoutPlanは0である場合があるため、初期値であるundefined以外の場合に取得済みとして扱う
      if (storedScout.scoutPlan !== undefined) {
        contract.value = storedScout;
        return;
      }

      // NOTE: スカウト以外のページ（例えば求人掲載/企業ページ）でブラウザリロードした時に、
      // スカウト契約情報が消えてしまう（root.$store.state.domains.user.scoutPlanがundefinedになる）ので、再取得する
      contract.value = await fetchAndStoreContract();
    };

    onMounted(() => {
      loadContract();
    });

    return {
      contract
    };
  }
});
